// While the AI assistant is open, keep the source element selected so its Redactor
// instance is not destroyed by stage clicks (see sc-35334).
// The lock is tied to the drawer content it was opened with, so it lapses when the
// drawer is closed, replaced, or the editor page unmounts.
let aiDrawerContent = null

export function setAiContentAssistantDrawer(content) {
    aiDrawerContent = content || null
}

export function isAiContentAssistantActive(siteDrawer) {
    if (!aiDrawerContent) return false
    return Boolean(siteDrawer?.isOpen) && siteDrawer.content === aiDrawerContent
}
